import React from "react";
import { useRecoilValue } from "recoil";
import { Grid, FormControlLabel, Radio } from "@mui/material";
import { GetTypographyContent } from "../shared/Typography/Typography";
import {
  NewReqTypographyLabel,
  NewReqInsuranceSheetText,
  NewReqInsuranceSheetWrapper,
} from "./NewRequisition.styles";
import { currentNewRequisitionEdit } from "../../recoil/atoms";
import { PrintIcon } from "../../assets/iconComponents/PrintIcon";

const NewReqBillToInsuranceAttach: React.FC = () => {
  const newRequisition = useRecoilValue(currentNewRequisitionEdit);
  const { requisitionForm } = newRequisition;
  return (
    <>
      <Grid item xs={3}>
        <FormControlLabel
          value="Attach"
          control={<Radio />}
          label={
            <NewReqTypographyLabel>
              {GetTypographyContent({
                content: "Attach a ",
                size: "medium",
                textColor: "greyMedium",
              })}
              {GetTypographyContent({
                content: "printed",
                size: "medium",
                textColor: "greyMedium",
                isBold: true,
              })}
              {GetTypographyContent({
                content: " insurance sheet",
                size: "medium",
                textColor: "greyMedium",
              })}
            </NewReqTypographyLabel>
          }
        />
      </Grid>
      {requisitionForm.billToInsuranceType === "Attach" && (
        <NewReqInsuranceSheetWrapper>
          <NewReqInsuranceSheetText>
            Please <b>print</b> and <b>attach</b> an insurance information sheet
            to the test kit.
          </NewReqInsuranceSheetText>
          <NewReqInsuranceSheetText>
            <PrintIcon />
            Please make sure to include the following information for claims to
            be processed correctly:
            <ul>
              <li>Insurance company name, group ID, and member ID</li>
              <li>Policy owner&apos;s first and last name and date of birth</li>
            </ul>
          </NewReqInsuranceSheetText>
        </NewReqInsuranceSheetWrapper>
      )}
    </>
  );
};
export default NewReqBillToInsuranceAttach;
